import { IPortalPageCard } from 'api/digifi/los/layout/CardsApi';
import { LayoutConfigurationEntityName } from 'enums/LayoutConfigurationEntityName';
import { LayoutConfigurationReferenceType } from 'product_modules/enums/LayoutConfigurationReferenceType';

import { createLayoutEntitiesSlice } from './createLayoutEntitiesSlice';

const {
  reducer,
} = createLayoutEntitiesSlice<
  IPortalPageCard
>({
  referenceType: LayoutConfigurationReferenceType.PortalPage,
  layoutConfigurationEntityName: LayoutConfigurationEntityName.Card,
});

export default reducer;
